<template>
	<div :class="style()">
		<router-view></router-view>
	</div>
</template>

<script>
	import ContentModal from '@ContentModal';
	import upsellMixin from '@/components/mixins/upsellMixin';
	import Upsell from '@/components/checkout/Upsell.vue';

	export default {
		mixins: [upsellMixin],
		computed: {
			route() {
				return this.$route;
			}
		},
		methods: {
			showUpsellModal() {
				const modalWidth = (this.$mq === 'mobile') ? '100%' : '1080px';
				if (this.getUpsellItems.length === 0) {
					return;
				}
				this.$modal.show(ContentModal, {
					contentComponent: Upsell,
					header: {
						title: 'Recommended Items',
						showBackButton: false,
					},
					footer: {
						showFooter: false,
					},
				}, {
					name: 'contentModal',
					width: modalWidth,
					height: 'auto',
					scrollable: true,
					clickToClose: false,
					delay: 200,
				});
			},
			style() {
				const hasContainerSpacing = (this.route.name !== 'order-confirmation');
				return {
					'container': true,
					'checkout-container': true,
					'full-height': true,
					'no-margin-top': true,
					'container-spacing': hasContainerSpacing,
					'minimal': this.$isMinimal,
				}
			}
		},
		created() {
			if (this.showUpsell && this.$route.name !== 'order-confirmation') {
				this.setupUpsellItems();
				this.showUpsellModal();
			}
		}
	}
</script>

<style lang="scss" scoped>
    @import 'globalStyles';
    .no-margin-top {
        margin-top: 0em !important;
	}
	.checkout-container {
		margin: auto;
	}
    @include mobile {
        .checkout-container {
			top: 0;
			padding-top: 0;
			width: 100%;
			overflow-y: hidden;
			&.minimal {
				padding: 0;
			}
		}
    }

</style>






// WEBPACK FOOTER //
// src/components/checkout/CheckoutContainer.vue